module.exports = __webpack_public_path__ + "img/backgroundhead1.b9ff0cdc.png";